import { render } from "./DevPage.vue?vue&type=template&id=da4095d8"
import script from "./DevPage.vue?vue&type=script&lang=js"
export * from "./DevPage.vue?vue&type=script&lang=js"
script.render = render

export default script